import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import { Form, Col, color, spacer } from 'stylist'
import Container from 'components/Container'
import PlainLink from 'components/PlainLink'
import { evenSplit, pickKeysThatStartWith } from 'utils'
import size from 'lodash/size'
import mapValues from 'lodash/mapValues'

const AutofillBox = styled(Col)`
  -ms-grid-column: 3;
  grid-column: 3;
  -ms-grid-row: 2;
  -ms-grid-row-span: 4;
  grid-row: 2 / -1;
  margin-left: ${spacer(3)};
`

const AutofillRow = styled(Container)`
  & {
    padding: 0;
    flex-direction: column;
  }

  &:first-child {
    font-weight: 500;
  }
`

const AutofillHeader = styled(AutofillRow)`
  & {
    padding-top: 0;
    border-bottom: 1px solid ${color('silver')};
  }
`

const AutofillLink = styled(PlainLink)`
  padding-top: ${spacer(3)};

  &.disabled {
    pointer-events: none;
    color: ${color('silver')};
  }
`

const handleEvenSplit = (qualID, allQuotas, setQuotas, completions) => {
  const quotasForSelected = pickKeysThatStartWith(allQuotas, `${qualID}_quota`)
  const newLimits = evenSplit(completions, size(quotasForSelected))
  let i = 0
  const newQuotas = mapValues(quotasForSelected, val => {
    const newVal = { ...val, limit: newLimits[i] }
    i += 1
    return newVal
  })
  setQuotas(Object.assign({}, allQuotas, newQuotas))
}

const QuotaAutofill = ({ disabled, qualID }) => (
  <AutofillBox>
    <Fragment>
      <AutofillHeader>Autofill Quotas/Limits</AutofillHeader>
      <Form.Field
        name="quotas"
        render={({ value: quotas, setValue: setQuotas }) => (
          <Form.Field
            name="completions"
            render={({ value: completions }) => (
              <AutofillRow>
                <AutofillLink
                  className={disabled ? 'disabled' : ''}
                  onClick={() =>
                    handleEvenSplit(qualID, quotas, setQuotas, completions)
                  }
                >
                  Even Distribution
                </AutofillLink>
              </AutofillRow>
            )}
          />
        )}
      />
    </Fragment>
  </AutofillBox>
)

export default QuotaAutofill



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/QuotaAutofill.js